import React, { useEffect, useState } from 'react'
import { format } from "date-fns";
import { parseToNumber, sleep} from "../../utils/helper";
import { Button, Thead, Tbody, Tr, Td, Input, Flex, Text, Box, IconButton, AlertDialog, Center, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, HStack, useDisclosure, Tooltip } from "@chakra-ui/react";
import { Table} from "@chakra-ui/react";
import { TiDelete, BiServer } from "react-icons/all";
import "./TouristAtTemple.css";
import { touristEachTempleColumn } from '../../constants/tableData';

function TouristEachTempleTable({data, filter, status, onSaveAll, onRevertAll, isAllowAdd, isAllowEdit}) {
    const [selected, setSelected] = useState([]);
    const { isOpen: isDeleteModalOpen, onOpen: onDeleteModalOpen, onClose: onDeleteModalClose } = useDisclosure();
    useEffect(()=>{
        //map all column and sum total of the colum
        touristEachTempleColumn.forEach((column) => {
            _calcSubTotal(column.columnId);
        })
    }, [])
    // This function is use to calculate the value in all the input when on key up
    const _calcNum = (id) => {
        touristEachTempleColumn.forEach((column) => {
            _calcSubTotal(column.columnId);
        })
    }

    // This function use to set input value to 0 when the input is empty
    const _invalidValue = (columnId, id) => {
        let inputValue = document.getElementById(`tourist-each-temple-${columnId}-${id}`);
        if(inputValue.value === ""){
            inputValue.value = 0;
        } else {
            inputValue.value = parseInt(inputValue.value)
        }
    }

    // This function is use to calculate Total value
    const _calcSubTotal = ( column ) => {
		let subColumn = document.getElementsByClassName(`tourist-each-temple-${column}`);

		let total = 0;
		for (let each of subColumn) {
            if(each.value === "") { each.value = 0}
			if (!isNaN(parseInt(each.value))) {
                total += parseInt(each.value)
            } else {
                total += parseToNumber(each.value)
            }
		}

		let totalColumn = document.getElementById(`total-tourist-each-temple-${column}`);
        if (totalColumn) {
                totalColumn.innerHTML = total;
        }
	};
  return (
    <>
        <AlertDialog motionPreset="slideInBottom" isOpen={isDeleteModalOpen} isCentered>
            <AlertDialogOverlay />

            <AlertDialogContent>
                <AlertDialogHeader fontSize="lg">Confirmation</AlertDialogHeader>

                <AlertDialogBody>
                    {`Are you sure you want to revert ${selected.length > 1 ? "these tourist at each temples?" : "this tourist at each temple?" }`}
                </AlertDialogBody>
                <AlertDialogFooter>
                    <HStack spacing="2">
                        <Button onClick={onDeleteModalClose}>No</Button>
                        <Button
                            colorScheme="red"
                            onClick={ async () => {
                                onRevertAll(selected)
                                await sleep(100);
                                onDeleteModalClose();
                            }}
                        >Yes</Button>
                    </HStack>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
        
        <Box style={{ position: "sticky", left: "0"}} w="100%" mb="10px">
            <Text textAlign="center" fontSize="25px" fontWeight="bold">Tourist at Each Temple</Text>
            {status === "filter" ? (
                <Text textAlign="center">Tourist at Each Temple from {format(new Date(filter?.dateFrom), "dd MMMM, yyyy")} to {format(new Date(filter?.dateTo), "dd MMMM, yyyy")}</Text>
            ) : status === "import" ? (
                <Text textAlign="center">Tourist at Each Temple from {data?.length > 0 && format(new Date(data[0]?.date), "dd MMMM, yyyy")} to {data?.length > 0 && format(new Date(data[data?.length - 1]?.date), "dd MMMM, yyyy")}</Text>
            ) : status === "retrieve" && filter !== undefined ? (
                <Text textAlign="center">Tourist at Each Temple from {format(new Date(filter?.dateFrom), "dd MMMM, yyyy")} to {format(new Date(filter?.dateTo), "dd MMMM, yyyy")}</Text>
            ) : ""}
        </Box>
        
        {data?.length > 0 ? (
            <Table w="5500px" size="sm" className="temple-table" borderRight="1px solid black">
                <Thead className='temple-thead'>
                    <Tr color="#4149BE" className='temple-thead-tr1' fontWeight="bold" textAlign="center" h="35px" >
                        <Td textAlign="center" p="0" bgColor='#4F81BD'>No.</Td>
                        <Td textAlign="center" p="0">Date</Td>
                        <Td textAlign="center" p="0">Hour</Td>
                        <Td textAlign="center" p="0">NATIONALITY</Td>
                        <Td textAlign="center" p="0">ANGKOR WAT WEST</Td>
                        <Td textAlign="center" p="0">ANGKOR WAT EAST</Td>
                        <Td textAlign="center" p="0">BAKHENG</Td>
                        <Td textAlign="center" p="0">BAYON WEST</Td>
                        <Td textAlign="center" p="0">BAYON EAST</Td>
                        <Td textAlign="center" p="0">BAYON NORTH</Td>
                        <Td textAlign="center" p="0">BAYON SOUTH</Td>
                        <Td textAlign="center" p="0">TA PROHM WEST</Td>
                        <Td textAlign="center" p="0">TA PROHM EAST</Td>
                        <Td textAlign="center" p="0">TA PROHM NORTH</Td>
                        <Td textAlign="center" p="0">BANTEAY KDEI WEST</Td>
                        <Td textAlign="center" p="0">BANTEAY KDEI EAST</Td>
                        <Td textAlign="center" p="0">KRAVAN</Td>
                        <Td textAlign="center" p="0">TA NEI</Td>
                        <Td textAlign="center" p="0">TAKEO</Td>
                        <Td textAlign="center" p="0">PREAH KHAN WEST</Td>
                        <Td textAlign="center" p="0">PREAH KHAN EAST</Td>
                        <Td textAlign="center" p="0">PREAH KHAN NORTH</Td>
                        <Td textAlign="center" p="0">NEAK PEAN</Td>
                        <Td textAlign="center" p="0">TA SOM</Td>
                        <Td textAlign="center" p="0">PRE RUP EAST</Td>
                        <Td textAlign="center" p="0">PRE RUP SOUTH</Td>
                        <Td textAlign="center" p="0">MEBON</Td>
                        <Td textAlign="center" p="0">BANTEAY SAMRE</Td>
                        <Td textAlign="center" p="0">BAKONG WEST</Td>
                        <Td textAlign="center" p="0">BAKONG EAST</Td>
                        <Td textAlign="center" p="0">LOLEI</Td>
                        <Td textAlign="center" p="0">PREAH KO</Td>
                        <Td textAlign="center" p="0">BANTEAY SREI</Td>
                        <Td textAlign="center" p="0">KBAL SPEAN</Td>
                        <Td textAlign="center" p="0">PHNOM KROM</Td>
                        <Td textAlign="center" p="0">WAT ATHWEA</Td>
                        <Td textAlign="center" p="0">BEND MEALEA</Td>
                        <Td textAlign="center" p="0">ស្ថានភាព</Td>
                    </Tr>
                </Thead>

                <Tbody>
                    {data?.map((data, index) =>  {
                        return (
                            <Tr key={index} h="25px">
                                {touristEachTempleColumn.map((item, i) => {
                                    return (
                                        <Td key={i} w={item.columnId === "n" ? "20px" : item.columnId === 'nationality' ? "120px" : "60px"} py="0" p="1">
                                            <Input
                                                padding="2px"
                                                width="100%"
                                                height="25px"
                                                textAlign="center"
                                                borderColor='gray.500'
                                                type={item.type}
                                                className={`tourist-each-temple-${item.columnId} ${item.readOnly ? "is-disable-input" : data.status === 1 ? "is-disable-input" : ""}`}
                                                id={`tourist-each-temple-${item.columnId}-${data.id}`}
                                                defaultValue={data[item.columnId]}
                                                onKeyUp={() => _calcNum(`${data.id}`)}
                                                onBlur={()=>{ _invalidValue(item.columnId, data.id)}}
                                            />
                                        </Td>
                                    )
                                })}
                                <Td w="5px" align='center' py="0">
                                    <Flex justifyContent='center'>
                                        <Button
                                            className={ data.status === 1 ? "ut-button-dark" : "ut-button-success" }
                                            w="20"
                                            h="30px"
                                            id={`btn-save-${data.id}`}
                                            onClick={() => onSaveAll([data])}
                                            hidden={!isAllowAdd}
                                        >
                                            {data.status === 1 ? "Saved" : "Save"}
                                        </Button>
                                        <Tooltip hasArrow label='Revert' color='black' bg="gray.300">
                                            <IconButton
                                                onClick={() => {
                                                    onDeleteModalOpen();
                                                    setSelected([data])
                                                }}
                                                id={`btn-revert-${data.id}`}        
                                                className={ data.status !== 1 ? "is-disable" : "" }
                                                variant="ghost"
                                                colorScheme="red"
                                                size="sm"
                                                icon={<TiDelete size="1.7rem" />}
                                                hidden={!isAllowEdit}
                                            />
                                        </Tooltip>
                                    </Flex>
                                </Td>
                            </Tr>
                        )
                    })}
                    <Tr h="35px">
                        {touristEachTempleColumn.map((item, i) => {
                            return (
                                <Td key={i} p="0" style={{backgroundColor: "#8497b0", color: "white", textAlign: "center"}}>
                                    { i === 2 ? "Total" : (i === 0 || i === 1 || i === 3) ? null : <span id={`total-tourist-each-temple-${item.columnId}`}/>}
                                </Td>
                            )
                        })}
                        <Td p="0" style={{backgroundColor: "#8497b0"}}></Td>
                    </Tr>
                </Tbody>
            </Table>
        ) : (
            <Center py="3" w="full" h="70vh" color="gray.400">
                <BiServer size="1.3rem" /> <Text fontSize="md">&nbsp;No data.</Text>
            </Center>
        )}
    </>
  )
}

export default TouristEachTempleTable
